import { RegistrationStatus } from "../User";

export const marinerStatusText = (status: string) => {
  switch (status) {
    case RegistrationStatus.CONFIRMED:
      return <span className="reg">REGISTERED</span>;
    case RegistrationStatus.FORCE_CHANGE_PASSWORD:
      return <span className="reg-pending">REGISTRATION PENDING</span>;
    default:
      return <span className="not-reg">NOT REGISTERED</span>;
  }
};
